import React, { useRef, useEffect, useCallback } from "react";
import "./orviewer.css";
import { GraphicService } from "Classes/GraphicService";
import { IProps } from "Classes/interfaces";
import { builder, loader, initialize, destroy } from "Classes/global";
import { dataEvents } from "Classes/Events";
import { useCmrAuth } from "state/CMRAuth";

export const ORViewer: React.FC<IProps> = ({ scene: sceneConf, sceneKey, hasThumbnail }) => {
    const divRef = useRef<HTMLDivElement>(null);
    const { getAccessToken } = useCmrAuth();

    const generateThumbnail = useCallback(async () => {
        if (!sceneKey) return;

        if (hasThumbnail) return;

        const token = await getAccessToken();

        const blob = await GraphicService.captureSceneBlob();

        if (!blob) return;

        const formData = new FormData();
        formData.append("sceneKey", sceneKey);
        formData.append("thumbnail", blob);

        await fetch(`${process.env.REACT_APP_API_URL}/api/thumbnail`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });
    }, [sceneKey, getAccessToken]);

    const handleAssetsLoaded = useCallback(async () => {
        loader.assetsloaded = true;
        builder.room.buildScene();

        await new Promise((resolve) => setTimeout(resolve, 300));

        await generateThumbnail();
    }, [generateThumbnail]);

    useEffect(() => {
        if (!divRef.current || !sceneConf) return;

        initialize();
        GraphicService.init(divRef.current, sceneConf.roomSize);
        GraphicService.loadHDRI("/assets/hdri/GSG_PRO_STUDIOS_METAL_003_sm.exr");
        GraphicService.enableShadows(false);
        builder.setup(sceneConf, loader);
        dataEvents.on("assetsLoaded", handleAssetsLoaded);

        return () => {
            dataEvents.off("assetsLoaded", handleAssetsLoaded);
            destroy();
            GraphicService.dispose?.();
        };
    }, []);
    return (
        <div>
            <div ref={divRef} id="orViewer" className="orviewer" />
        </div>
    );
};
